import { render } from "./SegmentPage.vue?vue&type=template&id=29c58f07"
import script from "./SegmentPage.vue?vue&type=script&lang=js"
export * from "./SegmentPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/pathways/SegmentPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29c58f07"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29c58f07', __exports__)) {
    api.reload('29c58f07', __exports__)
  }
  
  module.hot.accept("./SegmentPage.vue?vue&type=template&id=29c58f07", () => {
    api.rerender('29c58f07', render)
  })

}


export default __exports__